exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*,:after,:before{box-sizing:border-box}body,html{height:100%;position:relative}body{font-family:proxima-nova,arial,helvetica,sans-serif;font-weight:400;font-style:normal;max-width:100vw;height:100%;font-size:16px}body.no-scroll{position:fixed;overflow:hidden}.app__wrapper{position:relative;overflow-x:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./app/screens/App/styles/app.css
// module id = 106
// module chunks = 0